import { FormItem, Password } from '@formily/element'

import { createSchemaField } from '@formily/vue'

const { SchemaField } = createSchemaField({
  components: {
    FormItem,
    Password,
  },
})

export default {
  data() {
    const schema = {
      'type': 'object',
      'properties': {
        passwd: {
          'title': '新密码',
          'x-decorator': 'FormItem',
          'x-component': 'Password',
          'x-display': 'visible',
          'x-pattern': 'editable',
          'x-validator': [
            {
              min: 8,
              message: '密码长度为8-16位',
            },
            {
              max: 16,
              message: '密码长度为8-16位',
            },
          ],
          'x-component-props': {
            size: 'default',
          },
          'x-designable-id': 'esbhetbwko2',
          'x-index': 0,
        },
        confirmPwd: {
          'title': '确认新密码',
          'x-decorator': 'FormItem',
          'x-component': 'Password',
          'x-display': 'visible',
          'x-pattern': 'editable',
          'x-validator': [],
          'x-reactions': `{{(field) => {
              field.selfErrors = field.value && field.query('passwd').value() !== field.value ? '两次密码不一致' : ''
          }}}`,
          'x-component-props': {
            size: 'default',
          },
          'x-designable-id': 'tr4e2w8zt06',
          'x-index': 1,
        },
      },
      'x-designable-id': 'qwx29mhoeeq',
    }
    return {
      schema,
    }
  },
  render(h) {
    return (
      <FormLayout labelCol={6} wrapperCol={10}>
        <SchemaField schema={this.schema} />
        <FormDialog.Footer />
      </FormLayout>
    )
  },
}
